import { httpApi } from '@app/api/http.api'

export type AdditionalNotificationRecipientRequest = {
  name: string
  email: string
  description?: string
}

export type AdditionalNotificationRecipientResponse = {
  id: string
  name: string
  email: string
  description?: string
}

export type UpdateAdditionalNotificationRecipientRequest = {
  id: string
  data: AdditionalNotificationRecipientData
}

export type AdditionalNotificationRecipientData = { id: string; name: string; email: string; description?: string }

export type ToggleStatusRequest = {
  isActive: boolean
}

const ADDITIONAL_NOTIFICATION_RECIPIENTS = 'additional-notification-recipients'

export const getAllAdditionalNotificationRecipients = (): Promise<AdditionalNotificationRecipientResponse[]> =>
  httpApi
    .get<AdditionalNotificationRecipientResponse[]>(`${ADDITIONAL_NOTIFICATION_RECIPIENTS}/all`)
    .then(({ data }) => data)

export const getActiveAdditionalNotificationRecipients = (): Promise<AdditionalNotificationRecipientResponse[]> =>
  httpApi
    .get<AdditionalNotificationRecipientResponse[]>(`${ADDITIONAL_NOTIFICATION_RECIPIENTS}?active=true`)
    .then(({ data }) => data)

export const getAdditionalNotificationRecipientsByType = (
  notificationType: string,
): Promise<AdditionalNotificationRecipientResponse[]> =>
  httpApi
    .get<AdditionalNotificationRecipientResponse[]>(
      `${ADDITIONAL_NOTIFICATION_RECIPIENTS}?notificationType=${notificationType}`,
    )
    .then(({ data }) => data)

export const getAdditionalNotificationRecipient = (id: string): Promise<AdditionalNotificationRecipientResponse> =>
  httpApi
    .get<AdditionalNotificationRecipientResponse>(`${ADDITIONAL_NOTIFICATION_RECIPIENTS}/${id}`)
    .then(({ data }) => data)

export const createAdditionalNotificationRecipient = (payload: AdditionalNotificationRecipientData): Promise<string> =>
  httpApi.post<string>(`${ADDITIONAL_NOTIFICATION_RECIPIENTS}`, payload).then(({ data }) => data)

export const updateAdditionalNotificationRecipient = ({
  id,
  data,
}: UpdateAdditionalNotificationRecipientRequest): Promise<void> =>
  httpApi.patch<void>(`${ADDITIONAL_NOTIFICATION_RECIPIENTS}/${id}`, data).then(({ data }) => data)

export const deleteAdditionalNotificationRecipient = (id: string): Promise<AdditionalNotificationRecipientResponse> =>
  httpApi
    .delete<AdditionalNotificationRecipientResponse>(`${ADDITIONAL_NOTIFICATION_RECIPIENTS}/${id}`)
    .then(({ data }) => data)

export const toggleAdditionalNotificationRecipientStatus = (
  id: string,
): Promise<AdditionalNotificationRecipientResponse> =>
  httpApi
    .patch<AdditionalNotificationRecipientResponse>(`${ADDITIONAL_NOTIFICATION_RECIPIENTS}/${id}/toggle-status`)
    .then(({ data }) => data)
